<template>
  <div v-if="doc && user" class="modal" :class="{active: show}">
    <a class="modal-overlay" @click="close"></a>
    <div class="modal-container">

      <div class="modal-header">
        <a @click="close" class="btn btn-clear float-right" aria-label="Close"></a>
        <div class="modal-title h5">Send to {{user.email}}</div>
      </div>

      <div class="modal-body">
        <div class="content">

          <div class="form-group">
            <label class="form-label" for="input-example-3">Message</label>
            <quillEditor id="editor" v-model="message" :options="editorOptions" />
          </div>

          <div class="form-group">
            <label class="form-label">Format</label>
            <label class="form-radio">
               <input type="radio" name="format" v-model="format" :value="'pdf'">
               <i class="form-icon"></i> PDF
            </label>
            <label class="form-radio">
               <input type="radio" name="format" v-model="format" :value="'word'">
               <i class="form-icon"></i> Word
            </label>
          </div>

        </div>
      </div>
      <div class="modal-footer">
        <div class="columns">
          <div class="column col-9">
            <span v-if="sendError" class="label label-error">Something went wrong</span>
            <span v-if="success" class="label label-success">Success</span>
          </div>
          <div class="column col-3">
            <button class="btn" @click.prevent="send" :class="{loading: sending}">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'dispatchModal',
  props: {
    show: Boolean,
    doc: Object,
    user: Object,
    fileId: String
  },
  components: { quillEditor },
  data () {
    return {
      sending: false,
      sendError: false,
      success: false,
      format: 'pdf',
      message: '',
      editorOptions: {
        theme: 'bubble'
      }
    }
  },
  watch: {
    user: function () {
      if (this.user) {
        this.message = [
          'Hi ', this.user.profile.firstname, ',<br/>',
          'Please find attached your ',
          this.doc.name, '.'].join('')
      }
    }
  },
  methods: {
    close () {
      this.$emit('close')
      this.success = false
    },
    send () {
      this.sending = true
      this.sendError = false
      this.success = false
      axios.post('/api/docs/send', {
        fileId: this.fileId,
        format: this.format,
        doc_name: this.doc.name,
        firstname: this.user.profile.firstname,
        email: this.user.email,
        message: this.message
      })
      .then(res => {
        if (res.status === 200) {
          this.sending = false
          this.success = true
        }
      })
      .catch(e => {
        this.sending = false
        this.sendError = true
      })
    }
  }
}
</script>

<style scoped>
#editor {
  border: .05rem solid #caced7;
  border-radius: .1rem;
}
select.form-select option {
  position: relative;
  padding: .1rem .2rem .1rem 25px;
}
select.form-select option:before {
  content: "";
  border: 1px solid #116cd6;
  height: 12px;
  width: 12px;
  background: #fff;
  border-radius: 2px;
  position: absolute;
  left: 4px;
  top: 6px;
}
select.form-select option:checked:after {
  content: "L";
  position: absolute;
  color: #116cd6;
  left: 8px;
  top: 4px;
  -ms-transform: scaleX(-1) rotate(-35deg);
  -webkit-transform: scaleX(-1) rotate(-35deg);
  transform: scaleX(-1) rotate(-35deg);
  font-size: 11px;
  font-weight: bold;
}
.modal-footer .btn {
  background: #136efb!important;
  border-color: #136efb!important;
  color: #fff!important
}
.modal-footer .btn.loading::after {
  border-bottom-color: #fff;
  border-left-color: #fff;
}
</style>



// WEBPACK FOOTER //
// dispatchModal.vue?f0356a88